import { render } from "./CreateGroupsModal.vue?vue&type=template&id=1e2f622e&scoped=true"
import script from "./CreateGroupsModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupsModal.vue?vue&type=script&lang=js"

import "./CreateGroupsModal.vue?vue&type=style&index=0&id=1e2f622e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2f622e"]])

export default __exports__